<template>
  <v-menu offset-y :close-on-content-click="false" z-index="99" v-if="logNum">
    <template v-slot:activator="{ on }">
      <v-icon title="日志" class="mdi-rotate-180" color="amber" style="position: fixed;right:0;top:0;z-index:98;" v-on="on" @click="initLogs">mdi-rss</v-icon>
    </template>
    <v-card flat width="300">
      <v-card-subtitle class="d-flex">历史日志信息
        <v-spacer />
        <v-icon small color="primary" title="清除" @click="onClear">mdi-trash-can-outline</v-icon>
      </v-card-subtitle>
      <v-card-text class="pa-0">
        <v-list dense>
          <v-list-item v-for="(item,index) in logs" :key="index">
            <v-list-item-icon class="mr-0">
              <v-icon small :color="getItemColor(item)">{{getItemIcon(item)}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="caption">{{item.content}}</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data () {
    return { logs: [] }
  },
  computed: {
    ...mapState({ logNum: state => state.logNum }),
  },
  created () {
    let logs = sessionStorage.getItem('LOGS');
    this.$store.state.logNum = !logs ? 0 : JSON.parse(logs).length;
  },
  methods: {
    initLogs () {
      let ret = sessionStorage.getItem('LOGS');
      if (!ret) return [];
      this.logs = JSON.parse(ret).reverse();
    },
    getItemColor (item) {
      return item.type == 'info' ? 'gray' : item.type == 'error' ? 'red' : item.type == 'warn' ? 'orange' : item.type == 'success' ? 'green' : item.type == 'alert' ? 'blue' : 'primary';
    },
    getItemIcon (item) {
      return item.type == 'info' ? 'mdi-information-outline' : item.type == 'error' ? 'mdi-close-circle-outline' : item.type == 'warn' ? 'mdi-record-circle-outline' : item.type == 'success' ? 'mdi-check-circle-outline' : item.type == 'alert' ? 'mdi-alert-circle' : 'mdi-map-marker-question-outline';
    },
    onClear () {
      sessionStorage.removeItem('LOGS');
      this.$store.state.logNum = 0;
    }
  }
}
</script>